import { ApplicationType } from '@kros-sk/models';

import { InterceptUrlPredicate } from '../interceptor-fns/kros-auth-interceptor-fn';

const USER_ROLE_PREFIXES: Partial<Record<ApplicationType, string[]>> = {
  [ApplicationType.Invoicing]: ['ESW'],
  [ApplicationType.Warehouse]: ['WRHS'],
  [ApplicationType.DigitalOffice]: ['OFCE'],
  [ApplicationType.BusinessApp]: ['ESW', 'WRHS'],
};

export function getUserRolePrefix(applicationType: ApplicationType): string {
  const prefixes = getUserRolePrefixes(applicationType);
  return prefixes[0];
}

export function getUserRolePrefixes(applicationType: ApplicationType): string[] {
  return USER_ROLE_PREFIXES[applicationType] ?? [];
}

export const createInterceptedAuthUrlFilter = (
  gatewayApiUrl: string,
  searchApiUrl: string,
  excludedPaths: string[] = []
): InterceptUrlPredicate => {
  return (url: string): boolean => {
    const isTranslationFile = url.includes('/assets/i18n/');
    if (isTranslationFile) return false;

    const isGatewayRequest = url.includes(gatewayApiUrl);
    const isSearchRequest = url.includes(searchApiUrl);
    const isApiRequest = isGatewayRequest || isSearchRequest;
    if (!isApiRequest) return false;

    const isExcluded = excludedPaths.some((path) => url.includes(path));
    return !isExcluded;
  };
};
